import isSSR from '@calm/web-common/dist/isSSR';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum-slim';
import { Environment } from '@rhg/constants';
import beforeSend from './before-send';

if (!isSSR() && process.env.NEXT_PUBLIC_ENV !== Environment.LOCAL) {
    datadogRum.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID!,
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!,
        site: process.env
            .NEXT_PUBLIC_DATADOG_SITE as RumInitConfiguration['site'],
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
        // Should be combined x.y.z-evexia-env-hash
        version: process.env.NEXT_PUBLIC_VERSION,
        env: process.env.NEXT_PUBLIC_ENV,
        sessionSampleRate: 100,
        trackUserInteractions: false,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend,
    });
}
